import styled from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'
import { IconAvantStay } from '@avantstay/backoffice-vectors'

export const NavigationContainer = styled.nav`
  display: flex;
  align-items: center;

  & > svg {
    color: ${mainColors.neutralExtraDark};
  }
`

export const NavItem = styled.li<{ $isActive?: boolean }>`
  font-size: 16px;
  font-weight: 500;
  color: ${({ $isActive }) => ($isActive ? mainColors.accentLight : mainColors.neutralExtraDark)};
  padding-left: 15px;
  display: inline-flex;
  align-items: center;
  width: 100%;
  position: relative;

  .active & {
    color: ${mainColors.accentLight};

    &:after {
      content: '';
      position: absolute;
      top: -5px;
      bottom: -5px;
      left: -4px;
      width: 8px;
      border-radius: 4px;
      background-color: ${mainColors.accentLight};
    }
  }

  svg {
    margin-right: 10px;
  }
`

export const CustomNavLink = styled.div`
  display: block;
  align-items: center;
  width: 100%;
  margin-bottom: 30px;

  svg {
    margin-right: 15px;
  }
`

const MOBILE_SIDE_PANEL_WIDTH = 287

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.26);
  height: 100vh;
  width: 0;
  position: absolute;
  top: 0;
  left: ${MOBILE_SIDE_PANEL_WIDTH}px;
  z-index: -1;
  opacity: 0;

  &.is-open {
    left: 0;
    width: 100vw;
    opacity: 100;
  }
`

export const MenuContainer = styled.div`
  height: 100%;
  width: ${MOBILE_SIDE_PANEL_WIDTH}px;
  overflow: hidden;
  position: fixed;
  top: 0px;
  left: 0;
  display: flex;
  flex-direction: column;

  background: ${mainColors.primaryDark};
  list-style-type: none;
  -webkit-font-smoothing: antialiased;

  transform-origin: 0% 0%;
  transform: translate(-100%, 0);
  transition: transform 0.5s ease;

  &.is-open {
    transform: none;
  }

  a + ul {
    display: none;
  }

  a.active + ul {
    display: unset;
  }

  ul + a.active {
    margin-bottom: -5px;
  }
`

export const MenuItemsContainer = styled.div`
  height: 100%;
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    left: -30px;
    right: -30px;
    top: 0;
    bottom: 0;
    box-shadow: inset ${mainColors.primaryDark} 0 0 10px 10px;
    pointer-events: none;
  }
`

export const MenuItemsList = styled.ul`
  padding: 20px 0;
  margin: 0;
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
`

export const LogoContainer = styled.div`
  padding: 20px;
`

export const MobileLogo = styled(IconAvantStay)`
  width: 160px;
  height: 16px;
`

export const Footer = styled.div`
  width: 100%;
  height: 64px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: right;
  background-color: ${mainColors.primaryDark};
  flex-shrink: 0;
`

export const CloseMenuButton = styled.div`
  color: ${mainColors.neutralDark};
  padding: 10px;
`
